import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUser } from 'contexts';
import { getLastSaleDaybook } from '../redux/actions/salesInvoice';
import moment from 'moment';
import { getFinancialYears } from '../redux/actions/dashboard';

const useSalesLastDaybook = () => {
   const [selectedDaybookId, setSelectedDaybookId] = useState(null);
   const { user } = useUser();
   const dispatch = useDispatch();
   const lastSaleDaybook = useSelector((state) => state.sales.lastSaleDaybook);
   const financialYears = useSelector((state) => state?.dashboard?.financialYears);
   const financialYear = financialYears?.find((a) => a.financial_year === user?.financialYear);

   const getLastSalesDaybook = useCallback(async () => {
      if (user && user?.loginhistory?.companyId && financialYear?.financial_year) {
         await dispatch(getFinancialYears({ companyId: user?.loginhistory?.companyId }));
         const fromDate = moment(financialYear?.fy_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
         const toDate = moment(financialYear?.fy_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
         const params = {
            companyId: user.loginhistory.companyId,
            fromDate,
            toDate,
            ...(selectedDaybookId && { daybookId: selectedDaybookId }),
         };
         await dispatch(getLastSaleDaybook(params));
      }
   }, [dispatch, selectedDaybookId, user]);

   useEffect(() => {
      getLastSalesDaybook();
   }, [getLastSalesDaybook]);

   return {
      lastSaleDaybook,
      setSelectedDaybookId,
   };
};

export default useSalesLastDaybook;
